import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		newBusinessApplication_container: {
			display: 'flex',
			flexDirection: 'row',
			height: '100%',
		},
		newBusinessApplication_side: {
			display: 'flex',
			flexDirection: 'column',
			background: theme.palette.background.default,
			zIndex: theme.zIndex.drawer,
		},
		newBusinessApplication_content: {
			width: '100%',
			position: 'relative',
		},
	});
});

export default useStyles;
